import React, {useEffect, useState} from 'react';
import {IDriverRegistrationSettings} from "./interface";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {AdminDriverRegistrationSettingsService} from "./service";
import {ErrorToast, SuccessToast} from "../../shared/toasters/toasters";
import {InitEditorMulti} from "../../shared/tinyMce/InitEditorMulti";
import {Card, Col, Form, Row} from "react-bootstrap";
import RichTextEditor from "../../shared/editor/RichTextEditor";

const AdminDriverRegistrationSettings = () => {
    const [state, setState] = useState<IDriverRegistrationSettings | null>(
        null
    );
    const { t } = useTranslation();
    const navigate = useNavigate();

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setState(
            (prev) => ({ ...prev, [name]: value }) as IDriverRegistrationSettings
        );
    };
    const handleText = (text: string) => {
        setState((prev) => ({ ...prev, text }) as IDriverRegistrationSettings);
    };
    const submitHandler = () => {
        AdminDriverRegistrationSettingsService.create(state)
            .then((response) => {
                SuccessToast(t(`driver_registration.successfully_updated_settings`));
                setState(response.data);
            })
            .catch(ErrorToast)
    };

    useEffect(() => {
        AdminDriverRegistrationSettingsService.get()
            .then((response) => {
                const { data } = response;
                setState(data);
                InitEditorMulti(data?.text ?? "", handleText, ".text");
            })
            .catch(ErrorToast);
    }, []);

    return (
        <Form
            onSubmit={(e) => {
                e.preventDefault();
                submitHandler();
            }}
        >
            <Card>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <label htmlFor="title" className="required-field">
                                {t("global.title")}
                            </label>
                            <input
                                type="text"
                                name="title"
                                required
                                className="form-control"
                                onChange={changeHandler}
                                value={state?.title}
                            />
                        </Col>
                        <Col md={6}>
                            <label htmlFor="subTitle" className="required-field">
                                {t("global.subtitle")}
                            </label>
                            <input
                                type="text"
                                name="subTitle"
                                className="form-control"
                                onChange={changeHandler}
                                value={state?.subTitle}
                            />
                        </Col>
                        <Col md={12} className={'mt-3'}>
                            <RichTextEditor
                                label={t("global.text")}
                                value={state?.text ?? ""}
                                onChange={(newContent) =>
                                    setState((prev: any) => ({
                                        ...prev,
                                        text: newContent,
                                    }))
                                }
                            />
                        </Col>
                    </Row>

                    <div className="col-12 my-2 d-flex justify-content-end text-align-center">
                        <button
                            className="btn btn-info"
                            type={"button"}
                            onClick={() => {
                                setState(null);
                                navigate(-1);
                            }}
                        >
                            {t("global.cancel")}
                        </button>
                        <button className="btn btn-primary ms-3" type="submit">
                            {t("global.save")}
                        </button>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
};

export default AdminDriverRegistrationSettings;